<template>
    <div class="profile-filter">
        <div class="group-type-select">
            <b-form-group>
                <b-form-select
                    class="apprentice-primary-select"
                    id="type-select-group-type"
                    v-model="selectedGroupType"
                    :options="groupTypeOptions"
                    @change="updateGroupOptions">
                </b-form-select>
            </b-form-group>
        </div>

        <div
            class="las-group-select"
            v-if="selectedGroupType === 2 || selectedGroupType === 3">
            <b-form-group>
                <b-form-select
                    class="apprentice-primary-select"
                    id="type-select-group"
                    v-model="selectedLasGroup"
                    :options="lasOptions"
                    @change="updateLasGroup">
                </b-form-select>
            </b-form-group>
        </div>

        <div
            class="project-level-select"
            v-if="selectedGroupType === 1"
            v-for="(group, index) in groupSelects"
            :key="group.options.id"
            :class="index === 0 ? '' : 'hide-label'">
            <b-form-group>
                <b-form-select
                    class="apprentice-primary-select"
                    id="project-select-group"
                    :options="group.options"
                    text-field="name"
                    value-field="id"
                    @change="updateMainGroup(index, $event)"
                    :value="group.value">
                </b-form-select>
            </b-form-group>
        </div>
    </div>
</template>

<script>
import moment from 'moment/moment';

export default {
    name: 'design-2021-profiles-show-filters-component',
    props: {
        groupsIn: [Array, Object],
        lasGroupsIn: Array,
        lasMainGroupsIn: Array,
    },
    data() {
        return {
            selectedGroupType: 0,
            groupTypeOptions: [],
            selectedGroup: null,
            groupOptions: [],
            selectedSubGroup: null,
            subGroupOptions: [],
            selectedSecondSubGroup: null,
            secondSubGroupOptions: [],
            parents: [],
            groupSelects: [],
            selectedLasGroup: null,
            lasOptions: [],
            filterSession: {},
            storageName: `user-${this.$authUser.id}-profiles-filter`,
        };
    },

    methods: {
        updateGroupOptions(selected) {
            this.selectedGroup = null;
            this.selectedLasGroup = null;

            if (selected === 1) {
                if (this.groupSelects.length) {
                    this.groupSelects = [];
                }

                this.groupSelects.push({
                    options: [
                        {
                            name: this.$t('profile.all_projects'),
                            id: 0,
                        },
                        ...this.groupsIn,
                    ],
                    value: 0,
                });
            }

            if (selected === 2) {
                this.lasOptions = this.lasGroupsIn.map((lasgroup) => {
                    return {
                        value: lasgroup.id,
                        text: lasgroup.name,
                    };
                });
                this.lasOptions.unshift({ value: null, text: this.$t('profile.all_class_groups') });
            }

            if (selected === 3) {
                this.lasOptions = this.lasMainGroupsIn.map((maingroup) => {
                    return {
                        value: maingroup.id,
                        text: maingroup.name,
                    };
                });
                this.lasOptions.unshift({ value: null, text: this.$t('profile.all_main_groups') });
            }

            const filterSession = {
                selected_group_type: selected,
                expiry: new Date(),
            };

            localStorage.setItem(this.storageName, JSON.stringify(filterSession));

            this.$emit('update-group-type', selected);
        },

        updateLasGroup(selected) {
            const filterLasSession = {
                selected_group_type: this.selectedGroupType,
                selected_las_type: selected,
                expiry: new Date(),
            };

            localStorage.setItem(this.storageName, JSON.stringify(filterLasSession));

            this.$emit('update-las-group', selected);
        },

        updateMainGroup(groupIndex, groupId) {
            // index moet kijken op welke select iets veranderd wordt.
            // [{startgroup}, {children1}, {children2}, etc]

            const groupSelect = this.groupSelects[groupIndex];
            // select 1

            // a) eerst checken of dat we geneste childs moeten verwijderen van het scherm omdat keuze veranderd
            if (groupIndex + 1 < this.groupSelects.length) {
                // moeten de overige childs resetten, alleen als de waarde veranderd is
                if (groupSelect.value !== groupId) {
                    this.groupSelects.splice(groupIndex + 1);
                }
            }

            // b) (set value) selecteerd een groep in de "startgroep" dan zetten we value op groupSelects[0].value;
            groupSelect.value = groupId;

            // b) (check children) kijken of de groep children heeft, en in array zitten als dit het geval is.
            let children = null;

            for (const group of groupSelect.options) {
                if (group.id === groupId) {
                    children = group.children;
                }
            }

            if (children && Object.keys(children).length) {
                this.groupSelects.push({
                    options: [
                        {
                            id: 0,
                            name: this.$t('profile.all_projects'),
                        },
                        ...children,
                    ],
                    value: 0,
                });
            }

            let projectFilterSession = {
                selected_group_type: this.selectedGroupType,
            };

            let subProjects = [];

            if (this.groupSelects.length > 1) {
                for (const [index, subGroup] of this.groupSelects.entries()) {
                    if (index === 0) {
                        continue;
                    }

                    subProjects.push({
                        index: index,
                        id: subGroup.value,
                    });
                }
            }

            if (this.groupSelects) {
                if (this.groupSelects.length >= 2) {
                    projectFilterSession.selected_project_group = this.groupSelects[0].value;
                    projectFilterSession.selected_sub_project_group = subProjects;
                } else {
                    projectFilterSession.selected_project_group = this.groupSelects[0].value;
                }
            }

            projectFilterSession.expiry = new Date();

            localStorage.setItem(this.storageName, JSON.stringify(projectFilterSession));
            this.$emit('update-projects', groupId);
        },
    },
    mounted() {
        if (this.groupsIn.length || this.lasGroupsIn.length || this.lasMainGroupsIn.length) {
            if (this.groupsIn.length) {
                this.groupTypeOptions.push({
                    value: 1,
                    text: this.$t('profile.projects'),
                });
            }

            if (this.lasGroupsIn.length) {
                this.groupTypeOptions.push({
                    value: 2,
                    text: this.$t('profile.class_groups'),
                });
            }

            if (this.lasMainGroupsIn.length) {
                this.groupTypeOptions.push({
                    value: 3,
                    text: this.$t('profile.main_groups'),
                });
            }

            this.groupTypeOptions.unshift({
                value: 0,
                text: this.$t('profile.all_students'),
            });
        }

        if (localStorage.getItem(this.storageName)) {
            const now = moment();
            const sessionData = JSON.parse(localStorage.getItem(this.storageName));
            if (now.diff(sessionData.expiry, 'days') < 1) {
                this.selectedGroupType = sessionData.selected_group_type;
                this.updateGroupOptions(sessionData.selected_group_type);

                if (sessionData.selected_project_group) {
                    this.updateMainGroup(0, sessionData.selected_project_group);
                }

                if (sessionData.selected_sub_project_group) {
                    for (const subGroup of sessionData.selected_sub_project_group) {
                        this.updateMainGroup(subGroup.index, subGroup.id);
                    }
                }

                if (sessionData.selected_las_type) {
                    this.selectedLasGroup = sessionData.selected_las_type;
                    this.$emit('update-las-group', sessionData.selected_las_type);
                }
            } else {
                localStorage.removeItem(this.storageName);
            }
        }
    },
};
</script>

<style scoped lang="scss">
.profile-filter {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;

    > div {
        width: 100%;
        margin-bottom: map-get($grid-padding-spacing, 'fifteen');

        fieldset {
            margin-bottom: 0;
        }

        &:first-child:is(:last-child),
        &:nth-child(2):is(:last-child) {
            margin-right: 0;
        }
    }

    .apprentice-primary-select {
        margin-bottom: 0;
        min-width: 125px;
        max-width: 100%;
    }
}

.hide-label ::v-deep {
    .form-group {
        label {
            display: none !important;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'sm')) {
    .profile-filter {
        > div {
            width: auto;
            max-width: 250px;
            margin-right: $grid-gutter-width;
        }
    }
}
</style>
